/**
 * RoleAccessService.js
 * Reads Screen_access from sessionStorage (CacheProviderService) and provides helpers for
 * filtering side menu items, tabs, and sub-tabs by viewAccess / editAccess.
 */
import { getCachevalue } from "./CacheProviderService";

// Side menu label → screen title in Screen_access JSON
const MENU_LABEL_TO_SCREEN = {
  "Billing": "Home",
  "Specimen": "Specimen",
  "Reporting": "Reporting",
  "Credit Settlement": "Credit Settlement",
  "Reports": "Reports",
  "Masters": "Settings",
};

export function getScreenAccess() {
  try {
    const raw = getCachevalue("Scrren_access");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

/**
 * Returns true if the side menu item (identified by its label) should be visible.
 * Falls back to true when no Screen_access is stored (admin / no restriction).
 */
export function canViewSideMenu(label) {
  const access = getScreenAccess();
  if (!access) return true;
  const screenTitle = MENU_LABEL_TO_SCREEN[label] ?? label;
  const screen = access.find((s) => s.title === screenTitle);
  return screen ? screen.viewAccess : true;
}

/**
 * Returns true if a tab / sub-tab (identified by its menuName) should be visible.
 * Searches main_tabs and sub_tabs of all screens.
 * Falls back to true when no Screen_access is stored or title is not found.
 */
export function canViewTab(menuName) {
  const access = getScreenAccess();
  if (!access) return true;
  for (const screen of access) {
    for (const tab of screen.main_tabs || []) {
      if (tab.title === menuName) return tab.viewAccess;
      for (const sub of tab.sub_tabs || []) {
        if (sub.title === menuName) return sub.viewAccess;
      }
    }
  }
  return true; // title not in access config → visible by default
}

/**
 * Returns true if a tab / sub-tab has edit access.
 */
export function canEditTab(menuName) {
  const access = getScreenAccess();
  if (!access) return true;
  for (const screen of access) {
    for (const tab of screen.main_tabs || []) {
      if (tab.title === menuName) return tab.editAccess;
      for (const sub of tab.sub_tabs || []) {
        if (sub.title === menuName) return sub.editAccess;
      }
    }
  }
  return true;
}
